import {Box,Typography} from "@mui/material";
import { getGoogleDriveMediaUrl } from '../utils/getGoogleDriveMediaUrl';
import SmartImage from '../utils/SmartImage';
import stockBall from '../icons/stock_ball.jpg';

/**
 * Componente MajorInfoBox - Responsivo para notícia principal
 * 
 * @param {string} title - Título da notícia
 * @param {string} subtitle - Subtítulo da notícia
 * @param {string} mediaUrl - URL da imagem/mídia
 * @param {function} onClick - Função chamada quando a box é clicada
 * @param {boolean} isClickable - Se a box deve ser clicável
 */ 
export default function MajorInfoBox({title, subtitle, mediaUrl, driveFileId, thumbnailUrl, onClick, isClickable = false}){
    const normalizedUrl = getGoogleDriveMediaUrl(mediaUrl, driveFileId, undefined, thumbnailUrl);
    const finalUrl = normalizedUrl || stockBall;
    return <Box 
        sx={{
            width:{xs: "90vw", sm:480}, 
            minWidth: {xs: 300},
            maxWidth: {xs: 400, sm: 480},
            height:{xs: 300, sm:400}, 
            display:"flex", 
            flexDirection:"column",
            marginRight:{xs: 0, md: 2},
            marginLeft: {xs:2, md: 0},
            transition: 'all 0.2s ease-in-out',
            '&:hover': isClickable ? {
                '& .title-text': {
                    color: 'steelBlue',
                },
                '& .subtitle-text': {
                    color: 'steelBlue',
                }
            } : {}
        }}
    >
        <Box 
            onClick={isClickable ? onClick : undefined}
            sx={{
                height:{xs: 176, sm:256},  
                borderRadius:"0.75vw", 
                marginTop:2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                background: '#f5f5f5',
                cursor: isClickable ? 'pointer' : 'default'
            }}
        >
            {finalUrl && (
                <SmartImage 
                    src={finalUrl} 
                    alt={title}
                    driveFileId={driveFileId}
                    fallbackSrc={stockBall}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '0.75vw',
                        display: 'block'
                    }}
                />
            )}
        </Box>
        <Box sx={{height:100, marginY: 1}}>
            <Typography 
                className="title-text" 
                onClick={isClickable ? onClick : undefined}
                sx={{
                    fontFamily: "Atlan",
                    fontWeight: "bold",
                    overflow: "hidden",
                    wordBreak: "break-word",
                    maxHeight: "26px", 
                    fontSize:20,
                    transition: 'color 0.2s ease-in-out',
                    cursor: isClickable ? 'pointer' : 'default'
                }}
            >
                {title}
            </Typography>
            <Typography 
                className="subtitle-text" 
                onClick={isClickable ? onClick : undefined}
                sx={{
                    fontFamily:"Atlan",
                    overflow: 'hidden',
                    fontSize:18,
                    color: '#666',
                    display: '-webkit-box', 
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 3,
                    lineHeight: 1.3,
                    marginTop: 0.6, 
                    marginBottom: 1, 
                    height: "78px",
                    transition: 'color 0.2s ease-in-out',
                    cursor: isClickable ? 'pointer' : 'default'
                }}
            >
                {subtitle}
            </Typography>
        </Box>
    </Box>
}

            